import React from 'react';
import { Link } from 'react-router-dom';

const DeleteAccount = () => {
  return (
    <div>
      <section className="privacy-content">
        <div className="container">
          <Link to="/" className="back-link">← Back to Home</Link>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center', minHeight: '70vh' }}>
            {/* Content Section */}
            <div>
              <h1 style={{ color: '#dc3545', marginBottom: '2rem' }}>Delete Your Account</h1>

              <div style={{ backgroundColor: '#fff3cd', padding: '1.5rem', borderRadius: '8px', border: '1px solid #ffeaa7', marginBottom: '2rem' }}>
                <h3 style={{ color: '#856404', marginBottom: '1rem' }}>⚠️ Important Notice</h3>
                <p style={{ color: '#856404', marginBottom: '0' }}>
                  Account deletion is permanent and cannot be undone. Please read the information below carefully before proceeding.
                </p>
              </div>

              <h2 style={{ color: '#007bff', marginBottom: '1rem' }}>How to Delete Your Account</h2>

              <div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem' }}>
                <ol style={{ marginLeft: '1rem', lineHeight: '1.8' }}>
                  <li><strong>Open the Benefit Mankind app</strong> on your mobile device</li>
                  <li><strong>Go to your Profile</strong> by tapping the profile icon</li>
                  <li><strong>Scroll down to Account Settings</strong></li>
                  <li><strong>Tap "Delete Account"</strong> at the bottom of the settings</li>
                  <li><strong>Confirm your decision</strong> by following the on-screen prompts</li>
                  <li><strong>Your account will be deleted immediately</strong></li>
                </ol>
              </div>

              <h2 style={{ color: '#007bff', marginBottom: '1rem' }}>What Gets Deleted</h2>

              <div style={{ backgroundColor: '#d4edda', padding: '1.5rem', borderRadius: '8px', marginBottom: '1rem', border: '1px solid #c3e6cb' }}>
                <h4 style={{ color: '#155724', marginBottom: '1rem' }}>✅ Data That Will Be Removed:</h4>
                <ul style={{ color: '#155724', marginLeft: '1.5rem', lineHeight: '1.6' }}>
                  <li>Your full name and contact details</li>
                  <li>Profile picture and personal information</li>
                  <li>App preferences and settings</li>
                  <li>Push notification tokens</li>
                  <li>All personal account data</li>
                </ul>
              </div>

              <div style={{ backgroundColor: '#f8d7da', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '1px solid #f5c6cb' }}>
                <h4 style={{ color: '#721c24', marginBottom: '1rem' }}>📋 Data That Must Be Retained:</h4>
                <p style={{ color: '#721c24', marginBottom: '1rem' }}>
                  For legal compliance and administrative purposes, we must keep minimal donation records:
                </p>
                <ul style={{ color: '#721c24', marginLeft: '1.5rem', lineHeight: '1.6' }}>
                  <li><strong>Personal Data Kept:</strong> User ID and email address only</li>
                  <li><strong>Non-Personal Data:</strong> Donation amounts, project donations, donation dates, and transaction types</li>
                </ul>
                <p style={{ color: '#721c24', marginTop: '1rem', fontSize: '0.9rem', fontStyle: 'italic' }}>
                  This information is required for financial auditing, tax compliance, and charity reporting regulations.
                </p>
              </div>

              <h2 style={{ color: '#007bff', marginBottom: '1rem' }}>Need Help?</h2>
              <p style={{ marginBottom: '1rem' }}>
                If you're having trouble deleting your account or have questions about data retention, please contact our support team:
              </p>
              <div style={{ backgroundColor: '#e3f2fd', padding: '1rem', borderRadius: '8px' }}>
                <p style={{ marginBottom: '0.5rem' }}>
                  📧 <a href="mailto:info@benefitmankind.co.uk" style={{ color: '#007bff' }}>info@benefitmankind.co.uk</a>
                </p>
                <p style={{ marginBottom: '0' }}>
                  📞 <a href="tel:+441254602598" style={{ color: '#007bff' }}>01254 602598</a>
                </p>
              </div>
            </div>

            {/* Mobile App Screenshot */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ position: 'relative' }}>
                <img
                  src="/image_1.png"
                  alt="Delete Account Screen in Benefit Mankind App"
                  style={{
                    width: '300px',
                    height: 'auto',
                    borderRadius: '20px',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                    transform: 'rotate(-5deg)',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'rotate(-5deg) scale(1.05)'}
                  onMouseOut={(e) => e.target.style.transform = 'rotate(-5deg) scale(1)'}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '-20px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: '#007bff',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                }}>
                  Account Settings Screen
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DeleteAccount;
